import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import ReactStrapTable from 'components/reactStrapTable';
 import {PADetailDataColumns} from 'utils/columns';
import Loader from 'components/Loader';
import { onExport } from 'utils/helper';
import { cloneDeep } from 'lodash';
const PARatesDetails = (props)=>{
    const API = useAxios();
    const {dateRange, planId, groupId, filter} = props;
    const [summaryData, setSummaryData] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [totalSize, setTotalSize] = useState(0);

    const [state, updateState] = useState({
        filters: filter,
      });

      const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    useEffect(()=>{
        getPARatesDetailsData(state.filters);
    },[]);

    const getPARatesDetailsData = async(filters)=>{
        setSubmitting(true);
        try{
            const {data}= await API.post(
                `/PBMTenant/${planId}/PBMClientDashboard/getAuthDetails`, filters);
                if(data)
                {
                    setSummaryData(data.items);
                    setTotalSize(data.totalRecords);
                    setSubmitting(false);
                }
        }
        catch(ex)
        {
            setSubmitting(false);
        }
        
    };
    const { filters: colFilter } = state;

    const onPageChange = (filterr, hasColFilter, colChangedFilter) => {
            filter.pageSize = filterr.pageSize;
      filter.currentPage = filterr.currentPage;
        if (hasColFilter) {
          setState({
            filters: filter,
          });
          let colFilterOn = { ...filter, filters: colChangedFilter };
          getPARatesDetailsData();
        } else {
         var pageFilter = state.filters;
         pageFilter = {...state.filters, ...filter};
          setState({
            filters: pageFilter,
          });
          getPARatesDetailsData(pageFilter);
        }
      };

      const handleExport = async () => {
        const { access_token } = JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_PBMCONFIG_ENDPOINT}/PBMTenant/${planId}/PBMClientDashboard/getAuthDetailsExport?access_token=${access_token}`;
        onExport(action, state.filters);
      };

        const handleSearchColumnFilters = async (colFilter) => {
    const filterObj = cloneDeep(filter);
    if (colFilter && colFilter.length > 0) {
      filterObj.filters=colFilter;
    }
    getPARatesDetailsData(filterObj);
  };
  
   const handleFilterCancel = () => {
       var filterss = state.filters;
      const filterObj = cloneDeep(filterss);
   filterObj.filters=[];
getPARatesDetailsData(filterObj);
  };

    return (
        <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={summaryData?.length > 0 ? 'fixed-height' : 'default'}
        >
            {submitting && <Loader opacity={0.01} color='black' />}
            <ReactStrapTable
                id='invoicedetail-table'
                fixedColumn
                data={summaryData}
                filters={filter}
                columns={PADetailDataColumns}
                onPageChange={onPageChange}
                onPageSizeChange={onPageChange}
                hasPagination
                pageSize={colFilter.pageSize}
                currentPage={colFilter.currentPage}
                totalRecords={totalSize}
                   onFilterCancel={handleFilterCancel}
               onSearchColumnFilters={handleSearchColumnFilters}
                hasFilterColumn={false}
                onExport={handleExport}
                gridMsg="No Data"
            />
        </div>
    );
}

export default PARatesDetails;